import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/checkout';
export function StickyCta() {
  const [scrolledEnough, setScrolledEnough] = useState(false);
  const [offerInView, setOfferInView] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? window.scrollY / scrollable : 0;
      setScrolledEnough(progress > 0.7);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    const offer = document.getElementById('oferta');
    if (!offer) return;
    const observer = new IntersectionObserver(([entry]) => setOfferInView(entry.isIntersecting), {
      threshold: 0
    });
    observer.observe(offer);
    return () => observer.disconnect();
  }, []);
  const visible = scrolledEnough && !offerInView;
  return <AnimatePresence data-id="element-317" data-mp="27u88q0z2lx8">
      {visible}
    </AnimatePresence>;
}